export const hashtags = {
	bareoganics: ["BareOrganicsSuperfoods", "BareO", "BareOrganics", "BarelyUsedBareO"],
};
